<div class="link">
  <img src="assets/hash-blue.svg" alt="Hash Symbol" />
</div>
<div class="code-details">
  <span class="details clickable" (click)="viewDetails(project?._id)">
    {{ 'projectEstimate.estimateAndInvoice.main.projectDetails' | translate }}
    <img
      src="../../../../assets/right-arrow-circle-purple.svg"
      alt="project details"
      style="margin-left: 5px"
    />
  </span>
</div>
<div class="data">
  <app-project-card-data
    [isStatusPreview]="true"
    [project]="project"
    [isShowFiscalYear]="isShowFiscalYear"
  ></app-project-card-data>
</div>
